import { SORT } from '@/widgets/PaymentLinksHistoryFilters/model/constants'

export default {
  SET_PAGE(state, payload) {
    state.page = payload
  },
  SET_ITEMS(state, payload) {
    state.items = [...state.items, ...(payload.transactions || [])]
    state.total = payload.total
  },
  SET_SORTING(state, payload) {
    state.sort = payload
  },
  SET_FILTER(state, { key, value }) {
    state.filters[key] = value
  },
  SET_ALL_FILTERS(state, payload) {
    state.filters = payload
  },
  SET_RANGE(state, payload) {
    state.range = payload
  },
  SET_SEARCH(state, payload) {
    state.search = payload
  },
  CLEAR_ITEMS(state) {
    state.items = []
  },
  RESET_PAGE(state) {
    state.page = 1
    state.limit = 10
    state.items = []
  },
  RESET_FILTERS_AND_SORTING(state) {
    state.filters = {
      invoice_form_statuses: [],
      statuses: [],
    }
    state.sort = SORT[0].value
    state.range = []
    state.search = null
    state.selectedStatus = 'all'
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_SELECTED_STATUS(state, payload) {
    state.selectedStatus = payload
  },
  SET_STATUS_COUNTS(state, payload) {
    state.statusCounts = payload
  },
  RESET_STORE(state) {
    state.items = []
    state.page = 1
    state.limit = 10
    state.loading = false
    state.actionLoading = false

    state.filters = {
      invoice_form_statuses: [],
      statuses: [],
    }
    state.sort = SORT[0].value
    state.range = []
    state.search = null
    state.selectedStatus = 'all'
    state.statusCounts = {
      all: 0,
      active: 0,
      finished: 0,
    }
  },
}
